import React from "react";
import "./DiscoverArchiveSection2.scss";

const DiscoverArchiveSection2 = ({
  image,
  title = "FUNOONI ARCHIVE",
  subtitle2 = "funooni.com",
}) => {
  return (
    <section className="arc-archive-section">
      <div
        className="arc-archive-section__image"
        style={{
          backgroundImage: `linear-gradient(#6E6E6ECC, #D4D4D496), url(${image})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
      <div className="arc-left-archive-section">
        <div className="arc-div-left-archive-section">
          <div className="arc-archive-section__content">
            <div></div>
            <div>
              <h2 className="arc-archive-section__title">{title}</h2>
            </div>
          </div>
        </div>
      </div>
      <div className="arc-right-archive-section">
        <div className="arc-section__subtitle">
          <p className="arc-archive-section__subtitle">{subtitle2}</p>
        </div>
      </div>
    </section>
  );
};

export default DiscoverArchiveSection2;
